import { onMounted, watch, type Ref } from 'vue';
import { focusWithRetry } from '@/utils/focus';

type ShipmentFormBodyFocusPort = {
  focusActiveSection?: () => boolean;
};

function removeStepperFromTabOrder(root: ParentNode) {
  root.querySelectorAll<HTMLElement>('.p-step button, .p-step [tabindex="0"]').forEach(
    (el) => {
      el.tabIndex = -1;
    },
  );
}

export function useShipmentCreateWizardFocus(options: {
  wizardStep: Ref<number>;
  formBodyRef: Ref<ShipmentFormBodyFocusPort | null>;
  stepperRootRef?: Ref<HTMLElement | null>;
}) {
  async function focusActiveSectionWithRetry() {
    await focusWithRetry(
      () => options.formBodyRef.value?.focusActiveSection?.() ?? false,
    );
  }

  watch(
    () => options.wizardStep.value,
    (step, previous) => {
      if (previous === undefined) return;
      void focusActiveSectionWithRetry();
    },
  );

  onMounted(() => {
    if (options.stepperRootRef?.value) {
      removeStepperFromTabOrder(options.stepperRootRef.value);
    }
  });

  return {
    focusActiveSectionWithRetry,
  };
}
